<template>
  <Layout :footer-style="2" header-class="header-left-align" nav-alignment="right" :header-transparency="false" :show-top-header="true" buy-button-class="btn-default btn-small">
    <div class="rn-blog-details-area">
      <div class="post-page-banner rn-section-gapTop">
        <div class="container">
          <div class="row">
            <div class="col-lg-8 offset-lg-2">
              <div class="content text-center">
                <div class="page-title">
                  <h1 class="theme-gradient" v-html="news.title"/>
                </div>
                <ul class="rn-meta-list">
                  <li>
                    <Icon name="user" class="size-20"/> <router-link to="#">{{ news.author }}</router-link>
                  </li>
                  <li>
                    <Icon name="calendar" class="size-20"/> {{ news.createTime }}
                  </li>
                </ul>

              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="blog-details-content pt--60 rn-section-gapBottom">
        <div class="container">
          <div class="row">
            <div class="col-lg-8 offset-lg-2">
              <div class="content ql-editor">
                <p v-html="news.content"/>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
    import Layout from '../../components/common/Layout'
    import Breadcrumb from '../../components/elements/breadcrumb/Breadcrumb'
    import Icon from '../../components/icon/Icon'
    export default {
        name: 'HomeNewsDetails',
        components: {Icon, Layout, Breadcrumb},

        data() {
            return {
              id: this.$route.query.id,
              news: {}
            }
        },
        methods: {
            getPost(id) {
                this.postRequest("/system/web/news/"+id).then(resp=>{
                  this.news = resp.data;
                })

            }
        },
        mounted() {
            this.getPost(this.id);
        }
    }
</script>